export default __webpack_public_path__ + "static/media/ESTJ-3.9c7dce08.png";